import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { environment } from '@env';
import { HttpTransportType, HubConnection, HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';
import { ReplaySubject } from 'rxjs';
import { IRefreshedNotificationItem } from '../abstract/refreshed-notification-item';
import { IWebNotification } from '../abstract/web-notification';
import { RefreshNotificationItemAction } from '../constants/refresh-notification-item-action';

@Injectable({
    providedIn: 'root'
})
export class NotificationSignalRService {
    protected readonly baseUrl: string;
    protected hubConnection: HubConnection | null = null;

    webNotificationSub$ = new ReplaySubject<IRefreshedNotificationItem<IWebNotification>>(1);
    unreadWebNotificationSub$ = new ReplaySubject<number>(1);

    constructor(protected readonly http: HttpClient, @Inject("NOTIFICATION_BASE_URL") baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    getToken(): string | undefined {
        // TODO
        return undefined;
    }

    startConnection(): void {
        var url = `${this.baseUrl}notificationHub`;
        url = environment.production ? url : url + `?Authorization=${this.getToken()}`;

        this.hubConnection = new HubConnectionBuilder()
            .withUrl(url, HttpTransportType.WebSockets)
            .withAutomaticReconnect()
            .configureLogging(LogLevel.None)
            .build();

        this.hubConnection
            .start()
            .then(() => {
                this.hubConnection?.on("Notification", (data: IWebNotification) => {
                    this.webNotificationSub$.next({ action: RefreshNotificationItemAction.Prepend, value: data } as IRefreshedNotificationItem<IWebNotification>);
                });

                this.hubConnection?.on("UnreadWebNotifications", (data: number) => {
                    this.unreadWebNotificationSub$.next(data);
                });
            })
            .catch(err => {
                console.log(`Error while starting connection: ${err}`);
            });
    }

    isHubConnection(): boolean {
        return this.hubConnection != null && this.hubConnection.state === HubConnectionState.Connected;
    }
}